// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1820":"afcad136d72aebe7","2888":"5c874c559a964382","9167":"9b0b6b98d2a034ca","9922":"afcad136d72aebe7"}[chunkId] + ".css";
};